import BotResponseTreeNode from './BotResponseTreeNode';

class ResponseCardsTreeNodeItem {
  text: string;

  nextStep: BotResponseTreeNode | null;

  stepNumber: number | null;

  constructor(
    text: string = '',
    nextStep: BotResponseTreeNode | null = null,
    stepNumber: number | null = null
  ) {
    this.text = text;
    this.nextStep = nextStep;
    this.stepNumber = stepNumber;
  }
}

export default ResponseCardsTreeNodeItem;
